// config.js
const config = {
    currentEvent: "LACNIC41",
    pastEvent: "LACNIC40", 
    REACT_APP_EVENT_SLUG:"LACNIC41",
    REACT_APP_PAST_EVENT_SLUG:"LACNIC40",
    REACT_APP_API_URL_BASE: "https://apievt.lacnic.net/wp-json",
    REACT_APP_API_URL: "https://apievt.lacnic.net/wp-json/wp/v2",
    REACT_APP_API_URL_MENU: "https://apievt.lacnic.net/wp-json/menus/v1/menus",
    lacnogEvent: "LACNOG 2022",
    eventDate: "2024/05/06",
    // ID del evento actual (obtenidos desde WordPress)
    currentEventID: 179, 
    currentEventID_en: 181, 
    currentEventID_pt_br: 182,
    // ID del evento pasado (obtenidos desde WordPress)
    pastEventID: 157,
    pastEventID_en: 158,
    pastEventID_pt_br: 159,
    // Archivos de configuración Zona Horaria: HourRow.jsx, TimeZoneState.jsx
    eventTimeZone: 'America/Panama',
    utcEventTimeZone: 'GMT-0500',
    currentEventCountry: 'Panamá',
    currentEventCountryCode: 'PA',
    currentEventCountryFlag: '🇵🇦',
    currentEventPlace: 'Ciudad de Panamá, Panamá', 
    // URLs importantes
    registrationURL: 'https://eventos.lacnic.net/ev4/detail?id=lacnic41',
    menuEditorURL: 'https://apievt.lacnic.net/wp-admin/nav-menus.php?action=edit&menu=0&lang=es&admin_bar=1',
    pagesSetupCreatorURL: 'https://apievt.lacnic.net/wp-admin/post-new.php?post_type=pages-setup&lang=es',
    homepageCreatorURL: 'https://apievt.lacnic.net/wp-admin/post-new.php?post_type=homepage&lang=es',
    // Menu
    useAppMenu: false, // Cambia a true cuando quieras usar el menú de la app
  };
  
export default config;
